import { tns } from 'tiny-slider'

addEventListener('DOMContentLoaded', _ => {
    document.querySelectorAll('.column-carousel').forEach(el => {
        tns({
            container: el.querySelector('.item-wrapper'),
            items: parseInt(el.dataset.cols || 1),
            nav: false,
            prevButton: el.querySelector('.prev'),
            nextButton: el.querySelector('.next'),
            gutter: 48,
        })
    })
})
